export default __webpack_public_path__ + "static/5-9c081556af429ff44f0a62c715b382a6.jpg";